import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getUsuarios = async () => {
  const url = API_CONSTANT_MAP.usuario;
  return requestApi.get(url);
};

export const postUsuario = (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.usuario, payload);
};

export const getUsuarioById = async (id: string) => {
  const url = `${API_CONSTANT_MAP.usuario}/${id}`;
  return requestApi.get(url);
};

export const changePasswordUsuario = (id: string, password: string) => {
  return requestApi.put(`${API_CONSTANT_MAP.usuario}/${id}/change-password`, { password });
};
